export const FETCH_EMPRESAS_SUCCESS = 'FETCH_EMPRESAS_SUCCESS';
export const FETCH_EMPRESAS_FAILURE = 'FETCH_EMPRESAS_FAILURE';